import IconBase from './IconBase'
import { ReactComponent } from './light/grip-vertical.svg'

const GripVerticalIcon = (props: any) => <IconBase {...props} ReactComponent={ReactComponent} />

export default GripVerticalIcon
